import i18n from './index.js'
export default {//泰语
  translateText: {
    shoppingcart: "รถเข็น",
    loginorrefisterText: "ล็อกอิน/ลงทะเบียน",
    logoutText: "ออกจากการล็อกอิน",
    personcenterText: "ศูนย์ส่วนบุคคล",
    placeholderText: "โปรดเลือก",
    loginText: "ล็อกอิน",
    registerText: "ลงทะเบียน",
    emailText: "กล่องจดหมาย",
    pwdText: "รหัสผ่าน",
    forgetpwdText: "ลืมรหัส?",
    nameText: "ชื่อ",
    surnameText: "นามสกุล",
    mobileText: "โทรศัพท์",
    setPwdText: "ตั้งรหัสผ่าน",
    countryText: "ประเทศ",
    company: "บริษัท",
    birthday:"วันเกิด",
    yearText:"ปี",
    mouthText:"เดือน",
    dayText:"วัน",
    confirmpwdText: "ยืนยันรหัสผ่าน",
    agreeText1: "ฉันได้อ่าน และเห็นด้วย",
    agreeText2: "เงื่อนไขการใช้",
    agreeText3: "&",
    agreeText4: "คำแถลงความเป็นส่วนตัว",
    agreeText5: "และยอมรับว่า ข้อมูลส่วนบุคคลของฉันบางส่วนจะถูกจัดการในต่างประเทศตาม ที่ระบุไว้เป็นความเป็นส่วนตัว",
    emailplaceholder: 'กรุณาป้อนกล่องจดหมาย',
    subscribetitleText: 'สมัครรับจดหมายข่าวของเรา',
    subscribeText: 'สมัครสมาชิก',
    shareToText: 'แบ่งปัน',
    searchText: 'ค้นหา',
    subtractmoneyText: "น้อย ที่สุด 600",
    magnanimitycouponText: "คูปองคุณจะมารับของคุณ.",
    drawText: "รับทันที",
    discountText: "มันเป็นการลดราคา",
    purchaseText: "ซื้อทันที",
    composecouponText: "การซื้อแบบรวม",
    manyDiscountsText: "ข้อเสนอดีกว่า",
    recommendtitleText: "แนะนำให้คุณ",
    hotsaleproductyitleText: "ผลิตภัณฑ์ขายร้อน",
    guessLiketitleText: "เดาว่า คุณชอบ",
    NoDataText: "นับไม่ถ้วน",
    appraiseText: "การประเมิน",
    certificate: "คูปอง",
    collectText: "ของสะสม",
    addCartText: "เพิ่มรถเข็น",
    enterkeywordsText: "ป้อนคำสำคัญ",
    useNowText: "ใช้งานทันที",
    vouchernoText: "หมายเลขกำกับ",
    placeholderyearText:"เลือกปี",
    placeholdermouthText:"เลือกเดือน",
    placeholderdayText:"วัน ที่เลือก",
    // 优惠券页面
    breadcrumbItemText1: 'อัลตร้า',
    breadcrumbItemText2: 'ระดับ',
    breadcrumbItemText3: 'ใหญ่',
    breadcrumbItemText4: 'ขอบคุณ',
    breadcrumbItemText5: 'ลี',
    magnanimitydrawText: 'คูปองคุณจะมารับของคุณ.',
    availablecouponstitleText: 'คูปอง ที่มีอยู่',
    drawbtnText: 'เลือก',
    universalText: 'ทุกอย่างในบ้าน',
    useText: 'ใช้',
    limitText: 'จำกัด',
    fullText: 'เต็ม',
    subtractText: 'ลบ',
    // 折扣
    discountitemText1: 'ลดราคาอยู่เสมอ ,',
    discountitemText2: 'จูเฮอิน',
    // 组合
    commoditydiscountitemText1: 'การซื้อแบบรวม ,',
    commoditydiscountitemText2: 'ข้อเสนอดีกว่า',
    combinedpriceText: 'ราคารวม',
    economizeText: 'บันทึก',
    buynowText: "ซื้อทันที",
    // 产品
    ourproductsText: 'ผลิตภัณฑ์ของเรา',
    productcategoryText: 'หมวดหมู่สินค้า',
    recommendtarText: 'แนะนำ',
    newText: 'ของใหม่',
    salesvolumetarText: 'ยอดขาย',
    pricetarText: 'ราคา',
    // 博客
    blogmanagementText: "บล็อกยอดนิยม",
    latestblogsText: "บล็อกใหม่ล่าสุด",
    relatedrlogsText: "บล็อก ที่เกี่ยวข้อง",
    priceIncreasecommentText: "ส่งความคิดเห็น",
    commentsectionTtxt: "พื้น ที่แสดงผล",
    participatingcommentsText: "เกี่ยวข้องกับการแสดงความคิดเห็น",
    // 论坛
    postingText: "โพสต์",
    topicsText: "ชุดตก แต่ง",
    replyText: "ตอบกลับ",
    viewText: "แสดง",
    lastreplyText: "ตอบกลับล่าสุด",
    publishText: "ปล่อย",
    placeholdertypeText: "โปรดเลือกหมวดหมู่ของชุดตก แต่ง",
    placeholdertitleText: "โปรดป้อนคำบรรยาย",
    placeholdercontentsText: "โปรดป้อนเนื้อหา",
    fromtopicText: "จากชุดตก แต่ง:",
    firstfloor: "ชั้น 1",
    floorText: "ชั้นบน",
    fromText: "จาก:",
    postreplyText: "ตอบกลับ",
    // 个人中心 - 我的订单
    myorderText: "คำสั่งของฉัน",
    mycommentsText: "ความคิดเห็นของฉัน",
    mycollectionText: "ของสะสมของฉัน",
    couponText: "คูปอง",
    shippingaddressText: "ที่อยู่สำหรับการรับ",
    myPostText: "ของฉัน",
    personalinformationText: "ข้อมูลส่วนบุคคล",
    editText: "แก้ไข",
    allordersText: "รายการทั้งหมด",
    unpaidText: "อยู่จ่าย",
    shippedText: "กำลังส่งสินค้า",
    receivedText: "รับสินค้า",
    evaluatedText: "ความคิดเห็น",
    baidText: "แทน ที่",
    completedText: "เรียบร้อยแล้ว",
    productinfText: "ข้อมูลผลิตภัณฑ์",
    unitpricethText: "ข้อมูลผลิตภัณฑ์",
    quantitythText: "จำนวน",
    actualpaymentthText: "เงินสด",
    transactionstatusthText: "สถานะการซื้อขาย",
    operationthText: "การกระทำ",
    ordernumberText: "หมายเลขคำสั่ง",
    orderdetailsText: "รายละเอียดการสั่งซื้อ",
    cancelorderText: "ยกเลิกคำสั่งซื้อ",
    confirmText: "แน่ใจ",
    cancelText: "ยกเลิก",
    deleteordertitle: "ยืนยันการลบคำสั่งปัจจุบัน หรือไม่?",
    successfultradeText: "ข้อตกลงสำเร็จแล้ว",
    paymentText: "ชำระเงิน",
    confirmreceiptText: "ยืนยันการรับสินค้า",
    nncommentText: 'ยังไม่มีการแสดงความคิดเห็น',
    // 个人中心 - 我的评论
    productText: "ผลิตภัณฑ์",
    productdetailText: "รายละเอียดการประเมิน",
    replyblogText: "ตอบกลับไปยังบล็อก:",
    //个人中心 - 收货地址
    addseliveryaddressText: "เพิ่ม ที่อยู่สำหรับรับจดหมาย",
    addaddresstitleText1: "บันทึกแล้ว",
    addaddresstitleText2: "ที่อยู่ ที่เก็บข้อมูล",
    addaddresstitleText3: "ที่อยู่",
    defaultText: "ค่าปริยาย",
    consigneeText: "ผู้รับ:",
    addressText: "ที่อยู่:",
    fulladdressText: "รายละเอียด ที่อยู่:",
    setdefaultText: "ตั้งเป็นค่าปริยาย",
    mobilephoneText: "โทรศัพท์:",
    viewmoreText: "ดูเพิ่มเติม",
    replypostText: "ตอบกลับไปยังโพสต์:",
    // 个人中心 - 个人信息
    nameLabel:"ชื่อ",
    sexlabel:"เพศ",
    modifyavatarText:"แก้ไขภาพ",
    sexmanText:"ผู้ชาย",
    sexwomanText:"ผู้หญิง",
    secrecyText:"ความลับ",
    replaceText:"แทน ที่",
    saveText:"บันทึก",
    oldpasswordText:"รหัสผ่านดั้งเดิม",
    newpasswordText:"รหัสผ่านใหม่",
    confirmpasswordText:"ยืนยันรหัสผ่าน",
    opdpleasolderText:"โปรดป้อนรหัสผ่านเดิม",
    newpleasolderText:"โปรดป้อนรหัสผ่านใหม่",
    unboundText:"ไม่มีการเชื่อมต่อ",
    bindingText:"จับคู่",
    unbindingText:"แก้มัด",
    // 个人中心-个人信息
    regionText:"พื้น ที่",
    addconsigneleasolderText:"กรุณาใส่ชื่อของผู้รับ",
    countrypleasolderText:"โปรดเลือกประเทศ",
    provinceleasolderText:"โปรดเลือกจังหวะ",
    citypleasolderText:"โปรดเลือกตลาด",
    areapleasolderText:"โปรดเลือกพื้น ที่",
    fulladdressTextpleasolderText:"โปรดป้อน ที่อยู่โดยละเอียด",
    addconsignephoneleasolderText:"กรุณาใส่หมายเลขโทรศัพท์ของผู้รับ",
    emailpleasolderText:"โปรดป้อน ที่อยู่ของกล่องจดหมาย",
    phoneText:'เบอร์มือถือ',
    uploadimgText:"อัปโหลดรูปภาพ",
    updateuserface:"แก้ไขภาพ",
    uploadimgtitle1:"รองรับรูปภาพรูปแบบ jpg , png",
    uploadimgtitle2:"ขนาด ที่แนะนำ: 200 * 200 หรืออื่น ๆ รูปภาพ",
    updateemailText:"แก้ไขกล่องจดหมาย",
    updatemobileText:"แก้ไขหมายเลขโทรศัพท์",
    dialogemailtitle:"ที่อยู่กล่องจดหมาย",
    dialogmobiletitle:"เบอร์มือถือ",
    dialogheadertitle:" ป้อนความสัมพันธ์กับบัญชีผู้ใช้ของคุณ",
    continueText:"ทำต่อไป",
    verificationinformation:"ตรวจสอบข้อมูล",
    verificationinformationTitle1:"หากต้องการดำเนินการต่อโปรดทำขั้นตอนการตรวจสอบนี้ ให้เสร็จสิ้นเรากำลังไป",
    verificationinformationTitle2:"ส่งแคปช่าไปแล้วโปรดป้อนด้านล่าง",
    verificationcode:"ตรวจความถูกต้อง",
    newtitle:"สร้างใหม่",
    dialognewmobiletitle:"ป้อนหมายเลขโทรศัพท์ใหม่ ที่คุณต้องการเชื่อมต่อและคลิกเพื่อยืนยันการเปลี่ยน",
    confirmpbtnText:"ยืนยัน",
    titlecpuntryselect:"เลือกประเทศ",
    hotcountrytitle:"ประเทศยอดนิยม",
    aboutusText:"เกี่ยวกับเรา",
    // 订单详情
    havequestionsText:"ไม่แน่ใจ",
    preferentialText:"ข้อเสนอ",
    enquiryText:"สอบถามรายละเอียด",
    combinationdiscountText:"โปรโมชั่นรวม",
    introduceText:"แนะนำตัว",
    buyermycommentsText:"ความคิดเห็นของผู้ซื้อ",
    starText:"ดาว",
    yourmailboxText:"กล่องจดหมายของคุณ",
    placeholderquestionText:"กรุณาเขียนคำถามของคุณ",
    uploadimglimtText:"โปรดอัปโหลดไฟล์ JPG / GIF / PNGขนาดของภาพไม่เกิน 2 MB",
    submitbtnText:"ส่ง",
    // 购物车
    selectText:"การเลือก",
    tipscartsText:"เลือกผลิตภัณฑ์ (ไม่รวมค่าจัดส่ง)",
    settlementText:"การแลกเปลี่ยน",
    selectallText:"ตัวเลือกเต็ม",
    amountText:"จำนวนเงิน",
    addtofavoritesText:"เพิ่มรายการโปรด",
    havecollectedText:"ของสะสมแล้ว",
    tipdelecteproduct:"ยืนยันการลบรายการปัจจุบัน หรือไม่?",
    deleteText:"ลบ",
    tipclearcart:"แน่ใจนะว่า จะล้างรถขนของ?",
    clearcartText:"เคลียร์รถขนของ",
    totalText:"รวม",
    totaltipText:"รายการ (ไม่รวมค่าจัดส่ง) :",


    pieceText:"รายการ",
    freightText:"ค่าจัดส่ง:",
    taxationText:"ค่าภาษี:",
    fullreductionamountText:"จำนวนเงินเต็ม:",
    amountpayableText:"จำนวนเงิน ที่จ่าย:",
    confirmorderText:"ยืนยันการสั่งค่ะ",
    paymentsucceededText:"การชำระเงินสำเร็จ",
    receivinginformationText:"ข้อมูลการรับ",
    othershippingaddressText:"ที่อยู่สำหรับจัดส่งอื่น ๆ",
    addshippingaddressText:"เพิ่ม ที่อยู่สำหรับรับจดหมาย",
    selectshippingaddressText:"เลือก ที่อยู่ ที่จะรับ",
    selfprimingText:"เอามาเองสิ",
    typeofshippingText:"โหมดการจัดส่ง",
    inquirecostsText:"คลิก ที่นี่เพื่อปรึกษาการจัดส่ง",
    confirmproductinformationText:"ยืนยันข้อมูลผลิตภัณฑ์",
    settlementinformationText:"ข้อตกลง",
    clipcoupons:"ใช้คูปอง",
    allitemsText:"รายการทั้งหมด",
    validtoText:"หมดอายุจนถึง",
    pieceproductTotal:"รวมผลิตภัณฑ์:",
    placeorder:"ส่งคำสั่ง",
    consultText:"ที่ปรึกษา",
    consultationText:"โปรดป้อนเนื้อหา ที่ปรึกษา",
    sendoutText:"ส่งแล้ว",
    enterproductname:"ป้อนชื่อของผลิตภัณฑ์",
    contentText:"เนื้อหา",
    filerestrictionsText:"โปรดอัปโหลดไฟล์ JPG / GIF / PNG, ขนาดของภาพไม่เกิน 2 MB",
    withaccountText:"ป้อน ที่อยู่อีเมล ที่เกี่ยวข้องกับบัญชีของคุณ",
    pagelostText:"ขอโทษนะคะหน้า ที่คุณเข้าไปไม่มีการติดต่อสื่อสาร",
    pagelostText1:"กระโดดไปยังหน้าถัดไปโดยอัตโนมัติหลังจากวินาทีหากไม่ได้กระโดดคลิก ที่ปุ่มรีเฟรช",
    pagelostText2:"เรียกใหม่",
    pagelostText3:"กลับไปยังหน้าแรก",
    verificationrequiredText:"ต้องการการตรวจสอบ",
    continuestepemailText:"หากต้องการดำเนินการต่อโปรดทำขั้นตอนการตรวจสอบนี้ ให้เสร็จสิ้นเราได้ส่งอีเมล",
    sendcodeText:"ส่งแคปช่าไปแล้วโปรดป้อนด้านล่าง",
    resendverificationcodeText:"ส่งรหัสการตรวจสอบใหม่อีกครั้ง",
    createnewpasswordText:"สร้างรหัสผ่านใหม่",
    providepasswordText:"คุณต้องป้อนรหัสผ่านนี้ ทุกครั้ง ที่คุณเข้าสู่ระบบ",
    savechangeText:"บันทึกการเปลี่ยนแปลง และการล็อกอิน",
    shareToText1: 'follow us  on',
    productDetailsText:"รายละเอียดสินค้า",
    signedforText:"เซ็นรับแล้ว",
    rejectionText:"ขัดขืน",
    evaluated1Text:"ได้รับการประเมิน",
    reviewedText:"รอก่อน",
    PaidText:"ชำระเงินเรียบร้อย",
    subtotalText:"ขนาดเล็ก",
    waitingforpaymentText:"กำลังรอการชำระเงิน",
    automaticclosingText:"สำหรับการชำระเงินการสั่งซื้อหมดเวลาปิดอัตโนมัติ",
    patientText:"ลูกค้า ที่เคารพคำสั่งของคุณกำลังถูกส่งไปยังโรงเก็บกรุณารอสักครู่",
    consigneeinformationText:"ข้อมูลของผู้รับ",
    paymentinformationText:"ข้อมูลการชำระเงิน",
    paymentmethodText:"โหมดการชำระเงิน:",
    paymenttimeText:"เวลาการชำระเงิน:",
    fullnameText:"ชื่อเต็ม",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_th.js